import type { MouseEvent } from 'react';

const MIDDLE_BUTTON = 1;

type ActivationHandlers = {
  onClick: () => void;
  onAuxClick: (event: MouseEvent) => void;
};

export const reportOnActivation = (report: () => void): ActivationHandlers => ({
  onClick: report,
  // Chrome fires auxclick for a right-click too, which opens a menu rather than the link.
  onAuxClick: (event) => {
    if (event.button === MIDDLE_BUTTON) report();
  },
});
